import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'channel'
})
export class ChannelPipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (!value) return '-';

    const lower = value.toLowerCase();

    if (lower.includes('application programming interface')) {
      return 'API';
    }

    if (lower.includes('file transfer protocol')) {
      return 'FTP';
    }

    if (lower.includes('electronic number mapping')) {
      return 'ENUM';
    }

    return value;
  }
}
